import { Address } from '@models/address';

export interface BusinessLoginError {
  errorCode: BusinessLoginErrorCodes;
  errorMessage: any;
  httpStatusCode: number;
}

export enum BusinessLoginErrorCodes {
  INTERNAL_ERROR = 'INTERNAL_ERROR',
  BAD_REQUEST = 'BAD_REQUEST',
  USER_BLOCKED = 'USER_BLOCKED',
  BLOCKING_USER = 'BLOCKING_USER',
  USER_NOT_OPERATIVE = 'USER_NOT_OPERATIVE',
  UNAUTHORIZED = 'UNAUTHORIZED',
  UNVERIFIED_EMAIL = 'UNVERIFIED_EMAIL',
  OUTDATED_CERT = 'OUTDATED_CERT'
}

export interface BusinessLoginUserData {
  cif: string;
  nif: string;
  email?: string;
  signedToken?: string;
}

export interface BusinessCertificateInfo {
  subject: BusinessCertificateIdentification;
  issuer: BusinessCertificateIdentification;
  subjectaltname: string;
  infoAccess: {
    'CA Issuers - URI': string[];
    'OCSP - URI'?: string[];
  };
  serialNumber: string;
  parsedPoliciesIdentifiers?: string[];
}

export interface BusinessCertificateIdentification {
  C: string;
  O: string;
  OU: string;
  L: string;
  CN: string;
  title: string;
  organizationIdentifier: string;
  DC: string[];
  SN?: string;
  GN?: string;
  serialNumber?: string;
  description?: string;
}

export enum BusinessForwardEmailErrorCodes {
  INTERNAL_ERROR = 'SEM_000',
  FAILED_REQUEST = 'SEM_001',
  BAD_REQUEST = 'SEM_002',
  FAILED_MODIFY = 'SEM_003',
  FAILED_EMAIL = 'SEM_004',
}

export enum BusinessPinValidationErrorCodes {
  INTERNAL_ERROR = 'INTERNAL_ERROR',
  BAD_REQUEST = 'BAD_REQUEST',
  PIN_EXPIRED = 'EXPIRED_PIN',
  WRONG_PIN = 'WRONG_PIN',
}

// TODO: review codes
export enum BusinessCertificateErrorCodes {
  INVALID_CERTIFICATE = 'INVALID_CERTIFICATE',
  NOT_REPRESENTATIVE = 'CER_006',
  NOT_REPRESENTATIVE_OID = 'CER_008'
}

export enum BusinessClientVerificationErrorCodes {
  INTERNAL_ERROR = 'INTERNAL_ERROR',
  BAD_REQUEST = 'BAD_REQUEST',
  ALREADY_REGISTERED = 'ALREADY_REGISTERED',
  CLIENT_NOT_FOUND = 'CLIENT_NOT_FOUND',
  CLIENT_ERROR_NO_VALID_NODES = 'CLIENT_ERROR_NO_VALID_NODES',
  CLIENT_ERROR_MULTIPLE_NODES = 'CLIENT_ERROR_MULTIPLE_NODES',
}

export enum BusinessProfileErrorCodes {
  UNAUTHORIZED = 'UNAUTHORIZED',
  BLOCKING_USER = 'BLOCKING_USER',
  USER_BLOCKED = 'USER_BLOCKED',
  CREDENTIALS_ERROR = 'CREDENTIALS_ERROR',
  WRONG_PIN = 'WRONG_PIN',
  PIN_EXPIRED = 'PIN_EXPIRED',
}

export interface BusinessesClientCertificateResponse {
  status: string;
  status_code: string;
  body: {
    cif: string;
    nif: string;
    valid_date: string;
    company_name: string;
    token: string;
    certificate: BusinessCertificateInfo;
  };
}

export interface BusinessesClientVerificationResponse {
  token: string;
  address?: Address;
}

export interface BusinessRegisterClientRequest {
  auth: {
    password: string;
  };
  legalRepresentative: {
    email: string;
    name: string;
    surname1: string;
    surname2: string;
    birthdate: string;
    acceptAdvertising: boolean;
  };
  address: {
    street: string;
    postalCode: string;
    locality: string;
    streetType: string;
    number: string;
    additionalInfo?: string;
    floor?: string;
    portal?: string;
    door?: string;
    stair?: string;
  };
}
export interface BusinessRegisterClientSmsVerificationRequest {
  phone: string;
  legalRepresentative: {
    name: string;
    surname1: string;
    surname2: string;
  };
}

export interface BusinessesRegisterInfo {
  cif: string;
  nif: string;
  name?: string;
  surname1?: string;
  surname2?: string;
  birthDate?: string;
  socialPurpose?: string;
  phone?: string;
  email?: string;
  address?: Address;
  password?: string;
  acceptAdvertising?: boolean;
  clientCertificateToken?: string;
  verifiedClientToken?: string;
  unverifiedPhoneToken?: string;
  verifiedPhoneToken?: string;
  registeredClientToken?: string;
}

export const BUSINESS_CERTIFICATE_AUTHORITIES = [
  'OTRA ENTIDAD',
  'AC ABOGACIA',
  'Agencia de Tecnología y Certificación Electrónica - ACCV',
  'Agencia Notarial de Certificación',
  'ANF AC',
  'BEWOR',
  'BRANDDOCS',
  'CAMERFIRMA',
  'CERES Fábrica Nacional de Moneda y Timbre - Real Casa de la Moneda (FNMT-RCM)',
  'Coloriuris, Prestador de Servicios de Confianza (CIPSC)',
  'Consejo General de Colegios Oficiales de Médicos de España (AC-CGCOM)',
  'Consorci AOC (CATCert)',
  'CUSTOMER COMMS',
  'DIGITEL TS',
  'Dirección General de la Policía',
  'DOCUTEN',
  'EADTrust',
  'EDICOM',
  'ELECTRONIC IDENTIFICATION',
  'Entrust Datacard Europe S.L.',
  'ESFIRMA',
  'Evicertia',
  'EXAMINIS',
  'Firmaprofesional S.A.',
  'Izenpe, S.A.',
  'IVNOSYS',
  'Lleida.net',
  'Logalty Servicios de Tercero de Confianza S.L.',
  'MAILTECK',
  'Ministerio de Defensa de España',
  'Prestados de Servicios de Confianza MEYSS',
  'REGISTRADORES DE ESPAÑA',
  'SECTIGO',
  'Signaturit',
  'SIGNE Autoridad de Certificación',
  'UANATACA',
  'VALIDATED ID',
  'ViaFirma',
  'vinCAsign',
];
